import { render, staticRenderFns } from "./PrescriptionItemInfo.vue?vue&type=template&id=0d963c36"
import script from "./PrescriptionItemInfo.vue?vue&type=script&lang=js"
export * from "./PrescriptionItemInfo.vue?vue&type=script&lang=js"
import style0 from "./PrescriptionItemInfo.vue?vue&type=style&index=0&id=0d963c36&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports